module.exports = __webpack_public_path__ + "img/rtl.3ed2070b.jpg";